
import styles from "./Contact.module.css";
import Navbar from "../../../components/layout/navigation/v2/navBar";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faPhone,
    faEnvelope,
    faLocationDot
} from "@fortawesome/free-solid-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import FooterXsci from "../../../components/layout/footer/footer-xsci";

const Contact = () => {
    return (
        <>
            <Navbar />

            <main className={styles.contactPage}>
                <div className={styles.container}>
                    <h1>
                        Vous avez des questions ?
                        <span>Nous serons heureux de vous répondre.</span>
                    </h1>

                    <div className={styles.contactGrid}>

                        <a href="tel:5145459049" className={styles.contactCard}>
                            <div className={styles.icon}>
                                <FontAwesomeIcon icon={faPhone} />
                            </div>
                            <p>514-545-9049</p>
                        </a>

                        <a href="mailto:aquaticsvice@gmail.com" className={styles.contactCard}>
                            <div className={styles.icon}>
                                <FontAwesomeIcon icon={faEnvelope} />
                            </div>
                            <p>aquaticsvice@gmail.com</p>
                        </a>

                        <a
                            href="https://www.instagram.com/vice.aquatics/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.contactCard}
                        >
                            <div className={styles.icon}>
                                <FontAwesomeIcon icon={faInstagram} />
                            </div>

                            <p>Écrivez ou Suivez-nous sur Instagram </p>
                        </a>

                        <a
                            href="https://www.google.com/maps/search/?api=1&query=Sainte-Catherine+Quebec+J5C+1Y5"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.contactCard}
                        >
                            <div className={styles.icon}>
                                <FontAwesomeIcon icon={faLocationDot} />
                            </div>
                            <p>Sainte-Catherine, Quebec J5C 1Y5</p>
                        </a>

                    </div>
                </div>
            </main>
            <FooterXsci/>
        </>
    );
};

export default Contact;

